import {Component, Inject} from '@angular/core';
import {FileSystemFileEntry, NgxFileDropEntry} from 'ngx-file-drop';
import {TorchFilesService} from '@backend/modules/@files/services/torch-files.service';
import {UploadedFile} from '@backend/modules/@files/models/uploaded-file.model';
import {ConfirmationDialogService} from '../../services/confirmation-dialog.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class FileUploadDialogComponent {

  public single = false;
  public files: UploadedFile[] = [];
  private didChange = false;

  constructor(private filesService: TorchFilesService,
              @Inject(MAT_DIALOG_DATA) public data: { single: boolean },
              private dialogRef: MatDialogRef<FileUploadDialogComponent>,
              private confirmationDialogService: ConfirmationDialogService) {
    if (!!this.data) {
      this.single = this.data.single;
    }
  }

  public dropped(files: NgxFileDropEntry[]) {
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          const formData = new FormData();
          formData.append('file', file, droppedFile.relativePath);

          this.filesService.uploadFile(formData).subscribe((res: {file: UploadedFile}) => {
            this.didChange = true;
            this.files.push(res.file);
            if (this.single) {
              this.close();
            }
          });

        });
      }
    }
  }

  close() {
    this.dialogRef.close([this.didChange, this.files]);
  }

  deleteFile(file: UploadedFile) {
    this.confirmationDialogService.showConfirmationDialog('Delete File?', `Are you sure you want to delete the file '${file.fileName}'?`)
      .subscribe(confirmed => {
      if (confirmed) {
       this.filesService.deleteFile(file).subscribe(() => {
         this.files = this.files.filter(f => f.id !== file.id);
       });
      }

      if (this.files.length === 0) {
        this.didChange = false;
      }
    });
  }
}
